<template>
  <div class="orderMain advance-manage">
    <tr-list :request="'/BizMemberAdvance/myList'" ref="trList" :data="{}">
      <template slot="list" slot-scope="props">
        <router-link
          v-for="(item, index) in props.list"
          :key="index"
          :to="{
            path: '/advance/advanceDetail',
            query: { Id: item.Id, title: '预收详情', backUrl: 'manage', backQuery: JSON.stringify({ backUrl: 'home' }) },
          }"
          replace
        >
          <div class="card">
            <div class="content">
              <div class="status_tip" :style="(item.Status === '待支付' || item.Status === '退款中') ? 'background:#2FB08D' : (item.Status === '已取消' || item.Status === '线上退款') ? 'background:#909399': item.Status === '退款失败' ? 'background:#cb3535' : 'background:#E6A23C'">{{item.Status}}</div>
              <div style="display: flex;flex-direction: column;">
                <div class="card_title">
                  <span>{{ item.FullAddress }}</span>
                </div>
                <div class="card_RegionName">
                  <svg-icon class-name="dx-icon iconfont" icon-class="地址" color="#999999"></svg-icon>
                  <span>{{ item.RegionName }}</span>
                </div>
                <p class="card_tip">
<!--                  <span><svg-icon class-name="dx-icon iconfont" icon-class="user"></svg-icon>{{ item.Name }}</span>-->
<!--                  <span><svg-icon class-name="dx-icon iconfont" icon-class="iphone" color="#008f6a"></svg-icon>{{ item.Mobile }}</span>-->
                  <span>{{ item.PackageName }}</span>

                </p>

<!--                <van-tag color="#1989fa" plain>￥{{ item.Money }}</van-tag>-->
              </div>
<!--              <div class="rightButton">-->
<!--                <span :style="item.Status == '待支付' ? 'color:#E6A23C' : 'color:#2FB08D'">{{ item.Status }}</span>-->
<!--                <span style="color: #646566; margin-left: 10px">></span>-->
<!--              </div>-->
            </div>
            <p class="card_adr">
              <span>
                <span>租金： {{item.Price}}</span>
                <span>押金： {{item.Deposit}}</span>
              </span>
<!--              <span>{{ item.RegionName }}</span>-->
              <span>总计：￥{{ item.Money }}</span>
            </p>
          </div>
        </router-link>
      </template>
    </tr-list>

    <div id="add-order" class="add-order-new-style">
      <div class="bg" @click="addOrder">
        <van-icon name="plus" size="30px" color="#fff" />
        <div>新增预收</div>
      </div>
    </div>


    <van-popup v-model="show" get-container="body" style="width: 100%; height: 100%; overflow-y: auto">
      <div class="orderInfo" v-if="show">
        <van-field v-model="MemberData.Name" readonly label="姓 名："/>
        <van-field v-model="MemberData.StudentID" readonly label="学 号：" />
        <van-field v-model="MemberData.Mobile" readonly label="手 机："
                   :error-message="errorMsgMobile"
                   error-message-align="right"/>
        <van-cell-group class="adr">
<!--    is-link  required    @click="getDormitoryList"-->
          <van-cell title="地 址：" :value="MemberData.FullAddress ? MemberData.FullAddress : '请选择地址'">
            <template #title><span style="color: #646566">地 址：</span></template>
          </van-cell>
        </van-cell-group>
        <van-field
          :value="MemberData.Education1"
          is-link
          readonly
          @click="EducationClick1 = !EducationClick1"
          label="学 历："
        />
        <van-field
          :value="MemberData.Education2"
          is-link
          readonly
          @click="EducationClick2 = !EducationClick2"
          label="年 级："
        />
        <van-field v-model="MemberData.Major" clearable label="专 业：" />
        <van-field
          :value="PackageName"
          label="套 餐："
          is-link
          required
          readonly
          @click="getPackageList"
          :error-message="errorMsg"
          error-message-align="right"
        />
        <van-field readonly :value="Price" label="租 金：" />
        <van-field readonly :value="Deposit" label="押 金：" />
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="EndTime"
          label="结束时间："
          placeholder=""
        />
        <p style="padding: 10px 18px;font-size: 18px;color: #646566">支付方式：</p>
        <van-radio-group v-model="payType" class="pay-type">
          <van-cell-group>
            <van-cell title="微信支付" clickable @click="payType = 'onLine'">
              <template slot="title">
                <svg-icon slot="icon" icon-class="onLine" class-name="icon-onLine"></svg-icon>
                微信支付
              </template>
              <van-radio name="onLine" checked-color="#00d8a0"></van-radio>
            </van-cell>
            <van-cell clickable @click="payType = 'offline'">
              <template slot="title">
                <svg-icon slot="icon" icon-class="offline" class-name="icon-offline"></svg-icon>
                线下支付
              </template>
              <van-radio name="offline" checked-color="#00d8a0"></van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <div class="footer-btn-advance-manage">
        <van-button size="small" @click="show = false">取消</van-button>
        <wx-pay
            style="margin-left: 30px;"
            pay-url="/BizMemberAdvance/AdvancePay"
            :params="{ Id: ParentOrderId }"
            ref="refWxPay"
            class="pay-footer"
            @successPay="successPay"
            :control="payType === 'onLine'">
          <van-button size="small" type="primary" :disabled="allowed" @click="rule">提交</van-button>
        </wx-pay>
      </div>
    </van-popup>

    <van-popup v-model="EducationClick1" get-container="body" position="bottom">
      <van-picker
        :columns="Education1"
        show-toolbar
        title="在读学历"
        @cancel="EducationClick1 = !EducationClick1"
        @confirm="onConfirm1"
      />
    </van-popup>
    <van-popup v-model="EducationClick2" get-container="body" position="bottom">
      <van-picker
        :columns="Education2"
        show-toolbar
        title="在读学历"
        @cancel="EducationClick2 = !EducationClick2"
        @confirm="onConfirm2"
      />
    </van-popup>
    <van-popup
      v-model="PackageListShow"
      get-container="body"
      position="bottom"
      style="border-radius: 0; max-height: 80%"
    >
      <van-picker
        :columns="PackageList"
        show-toolbar
        title="选择套餐"
        @cancel="PackageListShow = !PackageListShow"
        @confirm="packageSelect"
      />
    </van-popup>
    <van-popup v-model="showPicker" get-container="body" position="bottom">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup
      get-container="body"
      v-model="DormitoryShow"
      position="bottom"
      style="border-radius: 0; height: 80%"
    >
      <div class="search">
        <van-search
          v-scrolltop
          v-model="value"
          placeholder="请输入搜索关键词"
          show-action
          shape="round"
          @search="onSearch"
          @clear="onClear"
        >
          <div slot="action" @click="onSearch">搜 索</div>
        </van-search>
        <div class="selected_popup" v-if="userAddress.length > 0">
          <h5><van-icon style="margin-right:5px;" name="wap-home" color="#39896f" size="14px"/>已选地址</h5>
          <!--<span @click="empty">清 空</span>-->
          <div class="address_ul_popup">
            <ul>
              <li v-for="(item, index) in userAddress"
                  :key="index"
                  @click="userAddressChange(item, index)">
                {{ item.name }}
                <van-icon name="success" color="#00982d"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="address-body"
        :class="userAddress.length > 0 ? 'hasUserAddress' : ''"
      >
        <div class="regionList">
          <template v-for="(item, index) in regionList">
            <van-cell @click="region(item, index)">
              <template slot="title">
                <span
                  >{{ item.Name }}
                  <span v-if="item.ExtendName"
                    >（{{ item.ExtendName }}）</span
                  ></span
                >
              </template>
            </van-cell>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "advance",
  data() {
    return {
      payType: 'onLine',
      errorMsgMobile: '',
      DormitoryShow: false,
      regionList: [],
      showAction: false,
      value: "",
      index: 0,
      userAddress: [],
      listType: "",
      allowed: false,
      PackageListShow: false,
      Education1: [],
      Education2: [],
      PackageList: [],
      EducationClick1: false,
      EducationClick2: false,
      PackageName: "",
      show: false,
      ParentOrderId: '',
      showPicker: false,
      MemberData: {
        Education1: '',
        Education2: '',
        Major: '',
        PackageId: ''
      },
      Price: 0,
      Deposit: 0,
      currentDate: new Date(),
      EndTime: '',
      errorMessage: "",
      errorMsg: "",
    };
  },
  computed: {},
  watch: {
    'MemberData.Mobile': {
      handler(){
        this.errorMsgMobile = "";
      }
    },
    PackageName() {
      this.errorMsg = "";
    },
  },
  methods: {
    getDormitoryList() {
      this.getregionList();
      this.DormitoryShow = !this.DormitoryShow;
    },
    empty() {
      this.userAddress = [];
    },
    userAddressChange(item, index, type = true) {
      // 筛选地址导航 根据点击数组的下标删除比下标大的数组项，并且根据当前点击判断请求接口， 如果大于0 则请求校区接口，然请求宿舍接口，传上一个userAddress数组的Id作为ParentId，如果上一个是userAddress数组的第一个，则直接请求校区接口
      const params = {};
      if (this.listType !== "onSearch") {
        this.value = "";
      }
      if (index === 0) {
        // 当地址导航点击下标为0时
        this.userAddress = []; // 清空
        this.getregionList();
      } else {
        this.userAddress = this.userAddress.filter(function (item, uIndex) {
          // 删除比当前点击下标大的数组
          return uIndex < index;
        });
        if (index === 1) {
          params.RegionId = this.userAddress[0].Id;
        } else {
          params.RegionId = this.userAddress[0].Id;
          params.ParentId = this.userAddress[index - 1].Id;
        }
        this.getList(params);
      }
    },
    onSearch() {
      this.listType = "onSearch";
      if (this.userAddress.length <= 0) {
        // 已选择地址 小于等于0时u，直接请求校区
        this.getregionList();
        return false;
      } // 否则请求
      const item = this.userAddress[this.userAddress.length - 1];
      this.userAddressChange(item, this.userAddress.length, false);
    },
    onClear() {
      this.onSearch();
    },
    getregionList() {
      this.$toast.loading({
        duration: 0,
      });
      const params = { Name: this.value };
      this.$post("/BizMemberRegion/AllList", params).then((res) => {
        if (res) {
          this.index = 0;
          this.regionList = res.Data;
          this.$toast.loading().clear();
        }
      });
    },
    getList(val) {
      this.$toast.loading({
        duration: 0,
      });
      const params = val;
      params.Name = this.value;
      this.$post("/BizMemberDormitory/AllList", params).then((res) => {
        if (res) {
          if (res.Data.length > 0) {
            this.regionList = res.Data;
          } else {
            // 如果已经加载完子级，则返回已选中的数据 this.userAddress
            // this.$router.go(-1);
            // this.$store.dispatch("setAddress", this.userAddress);
            let FullAddress = "";
            this.userAddress.forEach((item) => {
              FullAddress = FullAddress + "-" + item.name;
            });
            this.MemberData.FullAddress = FullAddress;
            this.MemberData.DormitoryId =
              this.userAddress[this.userAddress.length - 1].Id;
            this.DormitoryShow = !this.DormitoryShow;
            this.userAddress = [];
          }
          if (this.listType === "onSearch") {
            this.listType = "";
          }
          this.$toast.loading().clear();
        }
      });
    },
    region(item, index) {
      // 地址点击
      this.value = "";
      this.$toast.loading({
        duration: 0,
      });
      this.index++; // 设置点击次数，区分传参
      const params = {};
      if (this.index === 1) {
        // 判断当前点击为第一级的传参
        if (params.ParentId !== "") {
          this.$delete(params, "ParentId");
        }
        this.RegionId = item.Id; // 存下第一级参数
      } else {
        // 大于1的传参
        params.ParentId = item.Id;
      }
      if (item.ExtendName !== undefined) {
        this.userAddress.push({
          name: item.Name + "(" + item.ExtendName + ")",
          Id: item.Id,
        });
      } else {
        this.userAddress.push({
          name: item.Name,
          Id: item.Id,
        });
      }
      params.RegionId = this.RegionId;
      this.getList(params);
    },
    getPackageList() {
      this.$post("/BizMemberPackage/AllList", {
        DormitoryId: this.MemberData.DormitoryId,
        Type: "预收",
        State: "发布",
        Education: this.MemberData.Education1,
        Grade: this.MemberData.Education2,
      }).then((res) => {
        if (res) {
          this.PackageList = res.Data;
          this.PackageList.forEach((data) => {
            data.text = data.Name;
          });
          this.PackageListShow = true;
        }
      });
    },
    onConfirm1(value) {
      this.MemberData.Education1 = value.Value;
      this.PackageName = "";
      this.Price = "";
      this.Deposit = "";
      this.EducationClick1 = false;
    },
    onConfirm2(value) {
      this.MemberData.Education2 = value.Value;
      this.PackageName = "";
      this.Price = "";
      this.Deposit = "";
      this.EducationClick2 = false;
    },
    successPay(val) {
      // 支付回调
      this.$toast.loading().clear();
      this.$dialog
          .alert({
            message:
                val === "chooseWXPay:ok"
                    ? "订单支付成功！"
                    : "订单已经提交成功，请完成支付！",
          })
          .then(() => {
            this.$router.replace({name: 'advanceDetail', query: { Id: this.ParentOrderId, title: '预收详情', backUrl: 'manage', backQuery: JSON.stringify({ backUrl: 'home' })  }})
          });
    },
    sub() {
      this.allowed = true;
      this.$toast.loading({
        duration: 0,
      });
      let url = "/BizMemberAdvance/Add";
      let params = {
        Name: this.MemberData.Name,
        StudentID: this.MemberData.StudentID,
        Mobile: this.MemberData.Mobile,
        MemberId: this.MemberData.Id,
        DormitoryId: this.MemberData.DormitoryId,
        Education: this.MemberData.Education1,
        Grade: this.MemberData.Education2,
        Major: this.MemberData.Major,
        Price: this.Price,
        Deposit: this.Deposit,
        EndTime: this.EndTime,
        PackageId: this.MemberData.PackageId,
        IsOnline: this.payType === 'onLine'
      };
      this.$post(url, params).then((res) => {
        if (res.Status === 1) {
          this.ParentOrderId = res.Data
          this.allowed = false;
          if (this.payType === 'offline')  {
            this.$toast.loading().clear();
            this.errorMessage = "";
            this.show = !this.show;
            // this.$refs.trList.onRefresh();
            this.$toast(res.Message);
            this.$dialog.alert({
              message: "订单已经提交成功！",
            }).then(async () => {
              this.$router.replace({name: 'advanceDetail', query: { Id: res.Data, title: '预收详情', backUrl: 'manage', backQuery: JSON.stringify({ backUrl: 'home' })  }})
            });

          }
        } else {
          this.errorMessage = "";
          this.show = !this.show;
          this.$refs.trList.onRefresh();
          this.$toast.loading().clear();
          this.allowed = false;
          this.$toast.fail(res.Message);
        }
      });
    },
    rule() {
      if (this.MemberData.Mobile) {
        const phoneRegex = /^1[3456789]\d{9}$/
        if (!phoneRegex.test(this.MemberData.Mobile)){
          this.errorMsgMobile = '请输入正确的手机号'
        }
      }else {
        this.errorMsgMobile = '请输入手机号'
      }
      if (this.EndTime == "" || this.EndTime == null) {
        this.errorMessage = "请选择结束时间";
        if (!this.PackageName) {
          this.errorMsg = "请选择套餐";
        }
      } else {
        if (!this.PackageName) {
          this.errorMsg = "请选择套餐";
        }
      }
      if (this.EndTime && this.PackageName && this.MemberData.Mobile) {
        this.sub();
      }
    },
    formatter(time) {
      if (time == null) {
        return null;
      } else {
        let nowdata = time == null ? new Date() : new Date(time);
        let year = nowdata.getFullYear();
        let month = nowdata.getMonth() + 1;
        let date = nowdata.getDate();
        let nowtime = year + "-";
        if (month < 10) {
          nowtime += "0";
        }
        nowtime += month + "-";
        if (date < 10) {
          nowtime += "0";
        }
        nowtime += date;
        return nowtime;
      }
    },
    onConfirm(time) {
      this.EndTime = this.formatter(time);
      this.showPicker = false;
    },
    getMemberDetail() {
      this.$post("/BizMemberMember/DetailsByKey").then((res) => {
        if (res) {
          if (res.Data.Education) {
            res.Data.Education1 = res.Data.Education.split("|")[0];
            res.Data.Education2 = res.Data.Education.split("|")[1];
            res.Data.FullAddress =
              res.Data.RegionName + "-" + res.Data.FullAddress;
          }
          this.$set(this, 'MemberData', res.Data)
        }
      });
    },
    addOrder() {
      this.getMemberDetail();
      this.PackageName = "";
      this.Price = "";
      this.Deposit = "";
      this.EndTime = ''
      this.$toast.loading({
        duration: 1000,
        mask: true,
      });
      this.show = !this.show;
    },
    listData(list) {
      this.$toast.loading().clear();
      if (list.length <= 0) {
        this.PackageListShow = false;
        this.$toast("暂无有效订单！");
      }
    },
    packageSelect(item) {
      this.Price = item.Price;
      this.Deposit = item.Deposit;
      this.PackageName = item.Name;
      this.MemberData.PackageId = item.Id
      this.PackageListShow = !this.PackageListShow;
      this.EndTime = item.EndTimeStr
      // this.show = !this.show;
    },
  },
  created() {
    this.$post("/BizMemberDictionary/AllList", { ParetnName: "学历" }).then(
      (res) => {
        if (res) {
          this.Education1 = res.Data;
          this.Education1.forEach((data) => {
            data.text = data.Name;
          });
        }
      }
    );
    this.$post("/BizMemberDictionary/AllList", { ParetnName: "年级" }).then(
      (res) => {
        if (res) {
          this.Education2 = res.Data;
          this.Education2.forEach((data) => {
            data.text = data.Name;
          });
        }
      }
    );
  },
};
</script>

<style lang="less" scoped>
.pay-type{

  .van-cell__value {
    display: flex;
    justify-content: right;
  }
}
.selected_popup{
  padding:10px 0;
  h5{
    margin:0;
    padding:0 10px;
    color:#39896f;
  }
}
.address_ul_popup{
  padding:10px;
  background: #fff;
  border-bottom:4px solid #eee;
}
.address_ul_popup li{
  display: flex;
  justify-content: space-between;
  padding:5px 0;
  color:#333;
}
.address_ul_popup li:first-child{
  color:#303133;
  font-size:14px;
  font-weight: bold;
  &:after {
    display: none;
  }
}
.address_ul_popup li i{
  display: none;
}
.address_ul_popup li:last-child i{
  display: initial;
}
.card {
  margin: 15px;
  background-color: #fff;
  border-radius: 5px;
  .card_adr{
    padding:8px 15px;
    border-top:1px solid #eee;
    color:#999;
    margin-top:0;
    display: flex;
    justify-content: space-between;
    > span:last-child{
      color: #2d652e;
      font-size:14px;
      font-weight: bold;
    }
    > span:first-child{
        span{margin-right:20px}
    }
  }
  .content {
    display: flex;
    position: relative;
    padding: 15px;
    justify-content: space-between;
    .card_RegionName{
      color:#999;margin-top:3px;display: flex;align-items: center;
      svg{
        width: 16px; height: 16px;margin-right: 3px;
      }
    }
    .card_title{
      display: flex;font-weight: bold;align-items: center;
      span{
        font-size:16px;
      }
    }
    .status_tip{
      position: absolute;
      top: 15px;
      right: -10px;
      padding: 6px 15px;
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      color:#fff;
      font-size: 12px;
      &:after{
        //content: '';
        //position: absolute;
        //right: 0;
        //top:26px;
        //width:0;
        //height:0;
        //border-top: 7px solid #494949;
        //border-right: 10px solid transparent;
      }
    }
    .card_tip{
      margin:10px 0 0 0;
      box-sizing: border-box;
       span{
        font-size:12px;
        display: inline-block;
        svg{
          font-size:14px;
          margin-right:5px;
          color:#008f6a;
        }
      }
      > span:first-child{
        background: #fff;
        margin-right:5px;
        padding:3px 10px;
        border-radius: 5px;
        color:#008f6a;
        border: 1px solid #008f6a;
      }
       > span:last-child{
        background: #fff;
        margin-right:5px;
        padding:3px 10px;
        border-radius: 5px;
        color:#008f6a;
        border: 1px solid #008f6a;
      }
    }
    .card_adr{
      margin-bottom:0;
      color:#999;
    }
  }
  .rightButton {
    display: flex;
    align-items: center;
  }
}
.list-group,
.orderInfo {
  //padding: 12px 15px;
  box-sizing: border-box;
  line-height: 18px;
  position: relative;
  background-color: #fff;
  color: #323233;
  font-size: 16px;
  overflow: hidden;
  h1 {
    font-weight: normal;
    font-size: 16px;
    span {
      color: #969799;
      float: right;
    }
  }

  p {
    line-height: 20px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }
}
.add-order-new-style{
  z-index: 100;
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-40%);
  width: 130px;
  height: 58px;
  .bg{
    border: 2px solid #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #ffffff;
    background-color: #00d8a0;
    box-shadow: 0 5px 14.72px 1.28px rgba(0, 63, 47, 0.28);
    border-radius: 30px;
  }
}
</style>
<style lang="less">
.advance-manage{
  .customize{
    left: 50%!important;
    transform: translateX(-50%)!important;
    width: 100px!important;
    height: 100px!important;
    i{
      z-index: 2;
      font-size: 70px!important;
    }
  }
}
.orderInfo .van-cell span{
  font-size:16px;
}
.orderInfo .van-cell .van-field__control{
  font-size:16px;
  text-align: right;
}
.orderInfo .van-cell .van-field__control{
  text-align: right;
}
.orderInfo .adr .van-cell__title{
  flex:0;
  min-width:60px;
}

.orderMain {
  .icon-add-50 {
    i {
      &::before {
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        box-shadow: 0 10px 10px rgba(0, 216, 160, 0.2);
      }
    }
  }
  .van-field__body {
    height: 100%;
  }
  textarea {
    min-height: 100% !important;
    height: 100%;
    display: block;
  }
  .van-popup {
  }

}
.footer-btn-advance-manage {
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  >button:nth-child(2){
    margin-left: 30px;
  }
  button{
    border-radius: 6px;
    width: 50px;
  }
}
</style>
